"use strict";

exports.__esModule = true;
exports.ParsingError = void 0;
var _StringUtils = require("../Utils/StringUtils");
var _ConversionUtils = require("../Utils/ConversionUtils");
var _SessionError2 = require("../internal/SessionError");
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } /*
 * COPYRIGHT 2023 YOSPACE TECHNOLOGIES LTD. ALL RIGHTS RESERVED.
 * The contents of this file are proprietary and confidential.
 * Unauthorised copying of this file, via any medium is strictly prohibited.
 */
/**
 * An object containing details of any parsing errors that get reported
 *
 * @hideconstructor
 */
var ParsingError = exports.ParsingError = /*#__PURE__*/function (_SessionError) {
  _inheritsLoose(ParsingError, _SessionError);
  function ParsingError(breakId, message, errorDetail) {
    var _this;
    _this = _SessionError.call(this, (0, _ConversionUtils.millisToTimestamp)(Date.now())) || this;
    _this.message = message;
    var _errorDetail = (0, _StringUtils.isNullOrEmpty)(errorDetail) ? message : errorDetail;
    _errorDetail = _errorDetail + (!(0, _StringUtils.isNullOrEmpty)(breakId) ? " (breakId: " + breakId + ")" : "");
    _this.errorDetail = _errorDetail;
    return _this;
  }

  /**
   * @return {string} a descriptive message of the parsing error.
   */
  var _proto = ParsingError.prototype;
  _proto.getMessage = function getMessage() {
    return this.message;
  }

  /**
   * @return {string} a detailed description of the error.
   */;
  _proto.getErrorDetail = function getErrorDetail() {
    return this.errorDetail;
  };
  return ParsingError;
}(_SessionError2.SessionError);
ParsingError.Message = Object.freeze({
  BAD_XML: "XML is not well-formed",
  NO_VMAP: "Document is not VMAP",
  INCORRECT_VAST_VERSION: "Incorrect VAST version",
  INVALID_DURATION: "Invalid duration",
  INVALID_START_TIME: "Invalid start time",
  EMPTY_ADVERT_AND_TRACKING: "No adverts or tracking",
  INVALID_MEDIAID: "Yospace media id not found",
  MISSING_CREATIVE: "Missing Linear Creative",
  INVALID_TRACKING_URL: "Invalid tracking URL"
});